import { Component } from "./Component";
import { URLUtils } from "../libs/utils/URLUtils";
export class SearchField extends Component {
    constructor() {
        super(...arguments);
        this.onSubmit = (e) => {
            e.preventDefault();
            let query = this._form.querySelectorAll('input[name=query]')[0].value;
            const endpoint = this._form.querySelectorAll('input[name=endpoint]')[0].value;
            query = query.replace(/^\s+|\s+$/, '');
            if (query.length === 0) {
                return;
            }
            window.location.href = URLUtils.absUrl(URLUtils.joinUrl(endpoint, encodeURIComponent(query)));
        };
    }
    init() {
        this._form = this.getHtml('form');
        this._form.removeEventListener('submit', this.onSubmit);
        this._form.addEventListener('submit', this.onSubmit);
        const input = this.getHtml('input');
        input.addEventListener('touchstart', (e) => {
            input.focus();
            input.setSelectionRange(input.value.length, input.value.length);
        });
    }
}
